export const detalleModel = {
  dt: null,
  de: null,
  ca: '',
  dc: null,
  vm: null,
  st: false,
};

export const detailResponse = {
  dt: null,
  de: null,
  vm: null,
};
